import { customAxios, IDUSUARIO, ENTREGAS_URL } from '../constants';

export default function(pedidos) {

  const config = {
    params: {
      codpedido: pedidos.length < 1 ? '' : `${pedidos}`,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };
  return customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/validacion/pedidos`, config);
}



// WEBPACK FOOTER //
// ./src/utils/getvalidacionPedidos.js